import React from "react";
import mainImg from "./assets/criteria-10.2-rsp.jpg";

export default function Mobile({ common: { data } }) {
  return (
    <div className="layout-pic mobile">
      <div className="wrapper">
        <div className="main-img">
          <img src={mainImg} alt="" />
        </div>
        <div className="text-container">
          <div class="text-wrapper">
            <div class="excerpt1">Llámanos y continúa con tu solicitud</div>
            <div class="phone">
              <a href={`tel:${data.phone}`}>Llámanos</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
